import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { number, object, oneOfType, string } from 'prop-types';

export const Droppable = (props) => {
  const { id, children } = props;
  const { setNodeRef, isOver } = useDroppable({
    id: `droppable-${id}`,
    data: {
      ...props,
    }
  });

  const style = {
    height: '100%',
    zIndex: 99,
  };

  return (
    <div className={isOver ? 'activate-dropzone' : ''} ref={setNodeRef} style={style}>
      {children}
    </div>
  );
};

Droppable.propTypes = {
  id: oneOfType([number, string]),
  // eslint-disable-next-line react/forbid-prop-types
  children: object,
};

Droppable.defaultProps = {
  id: null,
  children: {},
};
